import { createJSONStorage, type StateStorage } from 'zustand/middleware';

/** localStorage that never throws (private windows, blocked storage, thumbnails): reads fall back to empty. */
const safeLocal: StateStorage = {
  getItem: (k) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  setItem: (k, v) => {
    try {
      localStorage.setItem(k, v);
    } catch {
      // storage unavailable: settings stay in memory for this tab
    }
  },
  removeItem: (k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      // ignore
    }
  },
};

export const safeStorage = createJSONStorage(() => safeLocal);

export function readLocal(key: string): string | null {
  return safeLocal.getItem(key) as string | null;
}
export function writeLocal(key: string, value: string | null): void {
  if (value === null) void safeLocal.removeItem(key);
  else void safeLocal.setItem(key, value);
}
